export default {"src":"/_next/static/media/King Bedframe.82b0b40f.svg","height":60,"width":110};